module.exports = __webpack_public_path__ + "static/media/Condeco_Logo_Large.43286f69.png";